export default "__VITE_ASSET__ByQsmB_O__"